import { render, staticRenderFns } from "./sticker.vue?vue&type=template&id=277ea211&"
import script from "./sticker.vue?vue&type=script&lang=js&"
export * from "./sticker.vue?vue&type=script&lang=js&"
import style0 from "./sticker.vue?vue&type=style&index=0&id=277ea211&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports